// extracted by mini-css-extract-plugin
export var change = "_3n-1";
export var changeList = "_3n-0";
export var changePath = "_3n-2";
export var diffArrow = "_3n-5";
export var diffRow = "_3n-3";
export var diffValue = "_3n-4";
export var error = "_3n-8";
export var notice = "_3n-9";
export var result = "_3n-6";
export var success = "_3n-7";